"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var keywords_editor_component_1 = __importDefault(require("../../components/keywords-editor/keywords-editor.component"));
/*  validation
 *    - 30文字以下
 *    - 重複なし
 *    - 他の node でも重複なし
 **************************/


var MAX_KEYWORD_LENGTH = 30;
exports.MAX_LENGTH_ERROR_MESSAGE = "\u30AD\u30FC\u30EF\u30FC\u30C9\u306F\u6700\u9577".concat(MAX_KEYWORD_LENGTH, "\u6587\u5B57\u3067\u3059!");
exports.DUPLICATE_ERROR_MESSAGE = "\u3059\u3067\u306B\u5B58\u5728\u3059\u308B\u30AD\u30FC\u30EF\u30FC\u30C9\u3067\u3059";
exports.ALREADY_TAKEN_MESSAGE = "\u3059\u3067\u306B\u4ED6\u306E\u3075\u304D\u3060\u3057\u3067\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u30AD\u30FC\u30EF\u30FC\u30C9\u3067\u3059";

exports.hanldeValidateKeyword = function (keywords, searchKeywords) {
  return function (keyword) {
    var error = null;

    if (keyword.length > MAX_KEYWORD_LENGTH) {
      error = exports.MAX_LENGTH_ERROR_MESSAGE;
    } else if (keywords.includes(keyword)) {
      error = exports.DUPLICATE_ERROR_MESSAGE;
    } else if (!!searchKeywords.find(function (_ref) {
      var label = _ref.label;
      return label === keyword;
    })) {
      error = exports.ALREADY_TAKEN_MESSAGE;
    }

    return {
      error: error
    };
  };
};

var CurrentNodeKeywordsEditorContainer = function CurrentNodeKeywordsEditorContainer() {
  var currentNodeId = react_redux_1.useSelector(scenario_selectors_1.selectCurrentNodeId);
  var keywords = react_redux_1.useSelector(scenario_selectors_1.selectCurrentKeywords);
  var searchKeywords = react_redux_1.useSelector(scenario_selectors_1.selectSearchKeywords);
  var dispatch = react_redux_1.useDispatch();
  return react_1.default.createElement(keywords_editor_component_1.default, {
    keywords: keywords,
    handleAddKeyword: function handleAddKeyword(keyword) {
      dispatch(scenario_actions_1.default.addKeyword({
        nodeId: currentNodeId,
        keyword: keyword
      }));
    },
    handleRemoveKeyword: function handleRemoveKeyword(keyword) {
      dispatch(scenario_actions_1.default.removeKeyword({
        nodeId: currentNodeId,
        keyword: keyword
      }));
    },
    validate: exports.hanldeValidateKeyword(keywords, searchKeywords)
  });
};

exports.default = CurrentNodeKeywordsEditorContainer;